export const USER_KEY = {
    subscription: '/user/check-subscription',
    generateKentId: '/generateKentId',
    getReferredUsers: '/user/referreds',
    getUser: '/users/me',
    connectAddress: '/user/connect/address',
    wallet: '/user/wallet',
    liderboard: '/liderboard',
    mining: '/user/mining',
}
